import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WelcomeWidgetComponent } from '../welcome-widget/welcome-widget.component';
import { PeopleYouMayKnowComponent } from '../people-you-may-know/people-you-may-know.component';
import { CollegueYouMayKnowComponent } from '../collegue-you-may-know/collegue-you-may-know.component';
import { SimilarBusinessNearYouComponent } from '../similar-business-near-you/similar-business-near-you.component';
import { SimilarCommunityComponent } from '../similar-community/similar-community.component';
import { CareonlineTodayComponent } from '../careonline-today/careonline-today.component';
import { TrendingPostComponent } from '../trending-post/trending-post.component';
import { TrendingCommunityComponent } from '../trending-community/trending-community.component';
import { TrendingHashtagComponent } from '../trending-hashtag/trending-hashtag.component';
import { JobsYouMightBeIntrestedInComponent } from '../jobs-you-might-be-intrested-in/jobs-you-might-be-intrested-in.component';
import { BusinessToFollowComponent } from '../business-to-follow/business-to-follow.component';
import { CommunitiesYouMayLikeComponent } from '../communities-you-may-like/communities-you-may-like.component';
import { HashtagsYouMayLikeComponent } from '../hashtags-you-may-like/hashtags-you-may-like.component';
import { InviteCollegueComponent } from '../invite-collegue/invite-collegue.component';
import { ConnectionsComponent } from '../connections/connections.component';
import { VisitorsComponent } from '../visitors/visitors.component';
import { CommunityAdminComponent } from '../community-admin/community-admin.component';
import { FollowCareonlineComponent } from '../follow-careonline/follow-careonline.component';

@Component({
  selector: 'app-widget',
  standalone: true,
  imports: [
    CommonModule,
    WelcomeWidgetComponent,
    PeopleYouMayKnowComponent,
    CollegueYouMayKnowComponent,
    SimilarBusinessNearYouComponent,
    SimilarCommunityComponent,
    CareonlineTodayComponent,
    TrendingPostComponent,
    TrendingCommunityComponent,
    TrendingHashtagComponent,
    JobsYouMightBeIntrestedInComponent,
    BusinessToFollowComponent,
    CommunitiesYouMayLikeComponent,
    HashtagsYouMayLikeComponent,
    InviteCollegueComponent,
    ConnectionsComponent,
    VisitorsComponent,
    CommunityAdminComponent,
    FollowCareonlineComponent
  ],
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss']
})
export class WidgetComponent implements OnInit {
  static BusinessToFollowComponent: any;
  suggestion: any;

  constructor() { }

  ngOnInit() {}

}
